module.exports = __webpack_public_path__ + "static/media/IdCard.8ac0d8e8.svg";